/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'goal-actions.goal-content-about.edit-description-error-description':
    'Something went wrong, try again in a few minutes.',
  'goal-content.goal-about-content.description-edit-button': 'Edit',
  'goal-content.goal-about-content.description-title': 'Description',
  'goal-content.goal-about-content.placeholder-description':
    'Briefly describe why this goal is important and how success is measured, so you can provide followers a common understanding.',
  'goal-content.goal-content-about.edit-description-error-title': 'Could not edit goal description',
  'goal-content.goal-content-update-date.edited': '(edited)',
  'goal-content.goal-content-update-date.edited-tooltip': 'Edited on {date}',
  'goal-content.goal-content-update-date.last-edited-by': '(last edited by {name})',
  'goal-content.goal-content-updates.add-update': 'Add update',
  'goal-content.goal-content-updates.archived': 'Archived',
  'goal-content.goal-content-updates.at-risk': 'At risk',
  'goal-content.goal-content-updates.cancelled': 'Cancelled',
  'goal-content.goal-content-updates.completed': 'Completed 🎉',
  'goal-content.goal-content-updates.date-changed': 'Date changed',
  'goal-content.goal-content-updates.edit-update': 'Edit',
  "goal-content.goal-content-updates.for-date'": 'for {dueDate}',
  'goal-content.goal-content-updates.latest-update-title': 'Latest update',
  'goal-content.goal-content-updates.missed-update-message': 'No update was posted',
  'goal-content.goal-content-updates.new-due-date': 'New due date',
  'goal-content.goal-content-updates.new-state': 'New state',
  'goal-content.goal-content-updates.no-updates-description': 'There are no updates for this goal yet.',
  'goal-content.goal-content-updates.off-track': 'Off track',
  'goal-content.goal-content-updates.old-due-date': 'Old due date',
  'goal-content.goal-content-updates.old-state': 'Old state',
  'goal-content.goal-content-updates.on-track': 'On track',
  'goal-content.goal-content-updates.paused': 'Paused',
  'goal-content.goal-content-updates.pending': 'Pending',
  'goal-content.goal-content-updates.previous-updates-title': 'Previous updates',
  'goal-content.goal-content-updates.share-update': 'Share',
  'goal-content.goal-content-updates.status-changed': 'Status changed',
  'goal-content.goal-content-updates.write-update-button': 'Write an update',
  'goal-content.goal-update-composer.modal-title': 'Post your update',
  'goal-content.goal-update-composer.post-button-label': 'Post update',
};
